<script>
import ReportNavigation from '@components/report-navigation.vue'

export default {
  components: { ReportNavigation },
  props: {
    report: {
      type: Object,
      required: true
    },
    slides: {
      type: Array,
      required: false,
      default: () => []
    },
    activeSlide: {
      type: Number,
      required: false,
      default: 0
    },
    goToSlide: {
      type: Function,
      required: false,
      default: () => { return function() {} }
    },
    isModalOpen: {
      type: Boolean,
      required: false,
      default: false
    },
    showDates: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<template>
    <section :class="[$style.wrapper, isModalOpen ? $style['modal-open'] : null]">
      <header :class="$style.header">
        <div :class="$style.headerWrapper" @click="goToSlide(0)">
          <img src="@assets/images/logo.svg" alt="Thatsup" />
          <transition name="date-appear">
            <div v-if="showDates" :class="$style.dates">
              <span :class="$style.headerWrapperCustomerName">
                {{ report.customer.name }} |
              </span>
              <BaseDate :date="report.from_date" /> - <BaseDate :date="report.to_date" />
            </div>
          </transition>
        </div>
      </header>
      <slot />
      <ReportNavigation :slides="slides" :active-slide="activeSlide" :go-to-slide="goToSlide" />
    </section>
</template>

<style lang="scss" module>
@import '@design';
body {
  background: $color-body-bg;
}
.wrapper {
    //background: $color-body-bg;
    position: relative;
    min-width: 100%;
    min-height: 100%;

    @extend %typography-small;

    @media screen and (min-width: $size-breakpoint-md) {
      padding-right: $size-grid-size * 27;
    }

    > * {
      transition: filter 0.3s ease;
    }
}
.modal-open {
  @media screen and (min-width: $size-breakpoint-sm) {
    > * {
      filter: blur(10px);
    }
  }
}
.header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: $layer-header-z-index;
  display: flex;
  align-items: center;
  height: $size-grid-size * 8;
  padding: 0 ($size-grid-size * 3);
  background: linear-gradient(to bottom, $color-body-bg, $color-body-bg-opacity 80%, $color-body-bg-transparent);

  @media screen and (min-width: $size-breakpoint-md) {
    padding: 0 ($size-grid-size * 3);
  }

  img {
    width: 80px;
    height: 24px;
    cursor: pointer;
  }
}
.headerWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.headerWrapperCustomerName {
  @media (max-width: 768px) {
    display: none;
  }
}
.dates {
  font-size: 12px;
  font-weight: bold;

  @media screen and (min-width: $size-breakpoint-sm) {
    font-size: 14px;
  }

  @media screen and (min-width: $size-breakpoint-lg) {
    font-size: 18px;
  }
}
</style>
<style lang="scss">
.date-appear-enter-active, .date-appear-leave-active {
  transition: all 0.3s ease;
}
.date-appear-enter, .date-appear-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}
</style>
